import React from 'react';
import { LockIcon, MailIcon, ShieldCheckIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
type TrustRowProps = {
  tone?: 'light' | 'dark';
  align?: 'start' | 'center';
  className?: string;
};
const items = [{
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: MailIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}];
export function TrustRow({
  tone = 'light',
  align = 'start',
  className
}: TrustRowProps) {
  return <ul className={twMerge('flex flex-wrap gap-x-5 gap-y-2 text-sm font-medium', tone === 'light' ? 'text-navy-soft' : 'text-white/90', align === 'center' ? 'justify-center' : 'justify-start', className)} data-id="element-457" data-mp="1k0yy3iyf9dxc">
      {items.map(({
      icon: Icon,
      label
    }) => <li key={label} className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-458" data-mp="3acn4gh48jzil">
          <Icon aria-hidden="true" className={twMerge('h-4 w-4', tone === 'light' ? 'text-teal' : 'text-teal-light')} data-id="element-459" data-mp="35e248hozhfu5" />
          {label}
        </li>)}
    </ul>;
}